module.exports = __webpack_public_path__ + "img/prototype-medical.6cfe0814.png";